export default __webpack_public_path__ + "static/media/july2023-4.c7ba0bb5.jpg";